import ROUTES_PATH from '@/router/routesPathConfig';

const routeSagas = {
  [ROUTES_PATH.COMPANIES.id]: { saga: () => import('@/pages/companies/sagas') },
  [ROUTES_PATH.AUTH_IDP_LOGIN.id]: { saga: () => import('@/pages/idp/sagas') },
  [ROUTES_PATH.REDIRECT.id]: { saga: () => import('@/pages/redirect/sagas') },
  [ROUTES_PATH.DOCUMENT_MOBILE_APPROVALS.id]: { saga: () => import('@/pages/mobile/approvals/sagas') },
  [ROUTES_PATH.ORGANIZATIONS.id]: { saga: () => import('@/pages/organizations/sagas') },
  [ROUTES_PATH.DOCUMENT.id]: { saga: () => import('@/pages/document/sagas') },
  [ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.id]: {
    saga: () => import('@/pages/company/WorkspaceRoute/redirectStandardSaga'),
  },
  [ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE_CATEGORY_UNDEFINED.id]: {
    saga: () => import('@/pages/company/WorkspaceRoute/redirectConfidentialSaga'),
  },
  [ROUTES_PATH.COMPANY.id]: { saga: () => import('@/pages/company/sagas') },
  [ROUTES_PATH.COMPANY_WORKSPACE.id]: { saga: () => import('@/pages/company/WorkspaceRoute/sagas') },
  [ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE.id]: {
    saga: () => import('@/pages/company/WorkspaceRoute/sagas'),
    sagasProps: {
      companyType: 'confidential',
    },
  },
  [ROUTES_PATH.COMPANY_DASHBOARD.id]: { saga: () => import('@/pages/company/DashboardRoute/sagas') }, // TODO: dashboard saga
  [ROUTES_PATH.COMPANY_DASHBOARD_VENDOR_EXPENSES.id]: {
    saga: () => import('@/pages/company/DashboardRoute/pages/VendorExpensesRoute/sagas'), // TODO: dashboard saga
  },
  [ROUTES_PATH.COMPANY_BANK_FEED.id]: { saga: () => import('@/pages/company/BankFeedRoute/sagas') },
  [ROUTES_PATH.ORGANIZATION_SETTINGS_USERS.id]: {
    saga: () => import('@/pages/configurations/organization/pages/Users/sagas'),
  },
  [ROUTES_PATH.ORGANIZATION_SETTINGS_SECURITY.id]: {
    saga: () => import('@/pages/configurations/organization/pages/Security/sagas'),
  },
  [ROUTES_PATH.ORGANIZATION_SETTINGS_BACKUPS.id]: {
    saga: () => import('@/pages/configurations/organization/pages/backups/sagas'),
  },
  [ROUTES_PATH.ORGANIZATION_SETTINGS_GENERAL.id]: {
    saga: () => import('@/pages/configurations/organization/pages/General/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS.id]: { saga: () => import('@/pages/configurations/company/sagas') },
  [ROUTES_PATH.COMPANY_SETTINGS_GENERAL.id]: {
    saga: () => import('@/pages/configurations/company/pages/General/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS_INTEGRATIONS.id]: {
    saga: () => import('@/pages/configurations/company/pages/Integrations/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS_APPLICATIONS.id]: {
    saga: () => import('@/pages/configurations/company/pages/applications/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS_VENDOR_PREFERENCES.id]: {
    saga: () => import('@/pages/configurations/company/pages/vendorPreferences/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS_APPROVALS.id]: {
    saga: () => import('@/pages/configurations/company/pages/approvals/sagas'),
  },
  [ROUTES_PATH.COMPANY_SETTINGS_BANK_FEED_CONNECTIONS.id]: {
    saga: () => import('@/pages/configurations/company/pages/BankFeed/pages/Connections/sagas'),
  },
  [ROUTES_PATH.PROFILE_SETTINGS_MAIN.id]: { saga: () => import('@/pages/profiles/company/pages/Main/sagas') },
  [ROUTES_PATH.PROFILE_SETTINGS_PREFERENCES.id]: {
    saga: () => import('@/pages/profiles/company/pages/preferences/sagas'),
  },
  [ROUTES_PATH.PAGE404.id]: { saga: () => import('@/pages/servicePage/sagas') },
  [ROUTES_PATH.PAY_COMPANY.id]: { saga: () => import('@/pages/dokkaPay/pages/company/sagas') },
  [ROUTES_PATH.PAY_PAYMENT.id]: { saga: () => import('@/pages/dokkaPay/pages/payment/sagas') },
  [ROUTES_PATH.PAY_COMPANY_SETTINGS.id]: { saga: () => import('@/pages/dokkaPay/pages/configurations/company/sagas') },
  [ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.id]: {
    saga: () => import('@/pages/dokkaPay/pages/configurations/company/pages/paymentProviders/sagas'),
  },
};

export default routeSagas;
